export const FETCH_BRANCHES_REQUEST = "FETCH_BRANCHES_REQUEST";
export const FETCH_BRANCHES_SUCCESS = "FETCH_BRANCHES_SUCCESS";
export const FETCH_BRANCHES_FAILURE = "FETCH_BRANCHES_FAILURE";
export const SET_ACTIVE_BRANCH = "SET_ACTIVE_BRANCH";
export const RESET_BRANCH = "RESET_BRANCH";
